import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRetrieveDocuments } from "@planzone/view-models";

import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Props } from "./types";
import { Folder } from "./folder";
import styles from "./styles.scss";

function FolderSelection({
  namespace,
  type,
  rootName,
  placeholder,
  selectedFolder,
  select,
}: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    folder,
    retrieveDocuments,
  } = useRetrieveDocuments(namespace, type);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveDocuments({ namespace, type });
  }, [namespace]);

  return (
    <SelectList
      rootClassName={styles.folderSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select: s }) => ({
        input: (
          <div
            className={classNames(styles.input, { [styles.opened]: isOpen })}
          >
            {selectedFolder ? (
              <p>
                {!!selectedFolder.name
                  ? selectedFolder.name
                  : rootName || t("folderCreation.folderSelection.root")}
              </p>
            ) : (
              <p className={styles.placeholder}>{placeholder}</p>
            )}
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            <Folder
              folder={folder}
              rootName={rootName || t("folderCreation.folderSelection.root")}
              selectedFolder={selectedFolder}
              select={(folder) => s(select(folder))}
            />
          </div>
        ),
      })}
    </SelectList>
  );
}

export { FolderSelection };
